import { render, staticRenderFns } from "./Step1Dev.vue?vue&type=template&id=20cf8de6&scoped=true&lang=pug"
import script from "./Step1Dev.vue?vue&type=script&lang=js"
export * from "./Step1Dev.vue?vue&type=script&lang=js"
import style0 from "./Step1Dev.vue?vue&type=style&index=0&id=20cf8de6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf8de6",
  null
  
)

export default component.exports